// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2b989150] .form_field .field.has-addons{flex-wrap:nowrap!important}", "",{"version":3,"sources":["webpack://./resources/client/components/record/RecordNextContact.vue"],"names":[],"mappings":"AAEA,gDACE,0BADF","sourcesContent":["\n\n::v-deep .form_field .field.has-addons {\n  flex-wrap: nowrap !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
